import { render, staticRenderFns } from "./digital-clock.vue?vue&type=template&id=c617fefc&scoped=true"
import script from "./digital-clock.vue?vue&type=script&lang=js"
export * from "./digital-clock.vue?vue&type=script&lang=js"
import style0 from "./digital-clock.vue?vue&type=style&index=0&id=c617fefc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c617fefc",
  null
  
)

export default component.exports